import { registerPlugin } from '@capacitor/core';
const UpdateManager = registerPlugin('UpdateManager');

export const installApk = async (path) => {
    await UpdateManager.installApk({ path });
};